import React, { useState, useEffect } from "react";
import TabsUnstyled from "@mui/base/TabsUnstyled";
import TabsListUnstyled from "@mui/base/TabsListUnstyled";
import TabPanelUnstyled from "@mui/base/TabPanelUnstyled";
import axios from "axios";
import TabUnstyled, { tabUnstyledClasses } from "@mui/base/TabUnstyled";
import { styled } from "@mui/system";
import "./ProfileTabs.css";
import ProfileTable from "../ProfileTable/ProfileTable";
import { CircularProgress } from "@mui/material";
import { URL } from "../../constants/constant";

const Tab = styled(TabUnstyled)`
  margin-right: 15px;
  border-radius: 5px;
  font-size: 15px;
  padding: 10px;
  border: none;

  &:hover {
    background-color: #03a9f4;
    color: white;
  }

  &:focus {
    color: #fff;
    border-radius: 3px;
    outline: 0px solid black;
    outline-offset: 0px;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: #2196f3;
    color: white;
  }
`;

export default function ProfileTabs() {
  const [profileLoader, setProfileLoader] = useState(false);
  const [profiles, setProfiles] = useState([]);
  useEffect(() => {
    setProfileLoader(true);
    var config = {
      method: "get",
      url: URL.demystify_url + "basicCaseData/profileInfo/",
      headers: {},
    };

    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data));
        setProfileLoader(false);
        setProfiles(response.data.message);
      })
      .catch(function (error) {
        setProfileLoader(false);
        console.log(error);
      });
  }, []);

  return (
    <div>
      {profileLoader ? (
        <div className="profile-loader">
          <CircularProgress />
        </div>
      ) : (
        <TabsUnstyled defaultValue={0} style={{ marginTop: 20 }}>
          <TabsListUnstyled>
            {profiles?.map((item,index) => {
              return (
                <Tab style={{ cursor: "pointer" , margin: "5px" }} key={index}>
                  {" "}
                  {item.profile}{" "}
                </Tab>
              );
            })}
          </TabsListUnstyled>
          {profiles?.map((item, index) => {
            return (
              <TabPanelUnstyled value={index} key={index}>
                <ProfileTable
                  rows={item.profile_names}
                  profile={item.profile}
                />
              </TabPanelUnstyled>
            );
          })}
        </TabsUnstyled>
      )}
    </div>
  );
}
